import React, { useEffect, useState } from "react";
import { StyleSheet, ScrollView, SafeAreaView } from "react-native";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useTheme } from 'react-native-paper';
import CustomGroup from "../../../components/AssessmentBuilderCmponent/Assessment/CostumGroup";
import { useAssessment } from "../../../hooks/useAssessment";

const EditGroup = (props) => {
    // * Get ID of Group to load 
    const groupId = props.groupId;
    const { user, clientApi, username } = useAuthContext();
    const { loadGroupById } = useAssessment();
    const [group, setGroup] = useState({})

    const { colors } = useTheme()
    const styles = makeStyles(colors)
    const title = group.description
    const flag = group.locked
    const [changeGroup, setChangeGroup] = useState({
        assmgroupUI: groupId, organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625", description: "", locked: "",
        require_login: true
    })

    // Load selected Group to the screen 
    useEffect(() => {
        loadGroupById(clientApi, user.token, username, groupId)
            .then(respGroup => {
                setGroup(respGroup)
            }).catch(error => {
                console.log(error)
            });
    }, [groupId]);

    useEffect(() => {
        const list = {
            assmgroupUI: group.assmgroupUI, organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625", description: title, locked: flag, require_login: true
        }
        setChangeGroup(list)
    }, [title, flag]);

    return (
        <SafeAreaView style={[styles.main]}>
            <ScrollView>
                <CustomGroup
                    group={changeGroup}
                    setGroup={setChangeGroup}
                    setShowResponseScreen={props.setShowResponseScreen}
                    setShowEditScreen={props.setShowEditScreen}
                    setShowEditGroup={props.setShowEditGroup}
                    setShowCreateScreen={props.setShowCreateScreen}
                    setShowMyAssessments={props.setShowMyAssessments}
                    setShowCreateGroup={props.setShowCreateGroup}
                    isCreate={1}
                    isEdit={1}
                    setShowAssessmentsAdmin={props.setShowAssessmentsAdmin}
                />
            </ScrollView>
        </SafeAreaView>
    );
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
    }
})

export default EditGroup; 